import { render, staticRenderFns } from "./ShipmentPoints.vue?vue&type=template&id=3e051032&"
import script from "./ShipmentPoints.vue?vue&type=script&lang=ts&"
export * from "./ShipmentPoints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports